module.exports = "/img/logo-unitel.svg?118db5867a36c0cf6fda0ec03efa1d3e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo-unitel.svg
// module id = RnnK
// module chunks = 46